import { Navigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectAuthentication } from '../redux/authenticationSlice'

export default function PrivateRoute({ children }) {

    const authentication = useSelector(selectAuthentication)
    const token = authentication?.token
    const tokenExpiresAt = authentication?.tokenExpiresAt
    const location = useLocation()
    const tokenIsValid = token && (!tokenExpiresAt || Date.parse(tokenExpiresAt) > Date.now())

    return tokenIsValid ? children : <Navigate to={"/welcome"} replace state={{ from: location }} />
}
